import { ultheraEvidenceCounts } from "../../evidence-counts"
import { ultheraEffectEvidenceReviews } from "../../effect/effect-real-data"
import { ultheraPainEvidenceReviews } from "../../pain/pain-real-data"
import { ultheraPriceEvidenceReviews } from "../../price/price-real-data"
import { ultheraRecoveryEvidenceReviews } from "../../recovery/recovery-real-data"

export const evidenceTopics = ["effect", "price", "reviews", "pain", "recovery", "side-effect"] as const

export type EvidenceTopicSlug = (typeof evidenceTopics)[number]

export interface EvidenceReview {
  sourceId?: string
  marker?: string
  grade?: "S" | "A" | "B" | "D" | "F"
  source: "네이버" | "구글" | "카카오" | "모두닥"
  date: string
  text: string
  tags: string[]
}

export interface EvidenceTopicData {
  slug: EvidenceTopicSlug
  label: string
  count: number
  articleTitle: string
  returnDescription: string
  reviews: EvidenceReview[]
  countedAt?: string
  nextUpdateAt?: string
}

export const evidenceTopicData: Record<EvidenceTopicSlug, EvidenceTopicData> = {
  'side-effect': {
    slug: 'side-effect', label: '부작용', count: ultheraEvidenceCounts['side-effect'],
    articleTitle: '울쎄라 부작용 글로 돌아가기',
    returnDescription: '시술 뒤 불편과 피해를 호소한 일곱 가지 증상을 이어서 읽어보세요.',
    reviews: [], countedAt: '2026.10.06', nextUpdateAt: '미정',
  },
  effect: {
    slug: "effect",
    label: "효과",
    count: ultheraEvidenceCounts.effect,
    articleTitle: "울쎄라 효과 글로 돌아가기",
    returnDescription: "직후와 몇 주 뒤, 서로 다른 효과 경험을 이어서 읽어보세요.",
    reviews: ultheraEffectEvidenceReviews.map((review) => ({ ...review, tags: [...review.tags] })),
    countedAt: "2026.08.25",
    nextUpdateAt: "미정",
  },
  price: {
    slug: "price",
    label: "가격",
    count: ultheraEvidenceCounts.price,
    articleTitle: "울쎄라 가격 글로 돌아가기",
    returnDescription: "‘같은 샷이어도 조건은 달랐어요’ 여섯 문장 중 아직 못 읽은 게 있다면 이어서 보세요.",
    reviews: ultheraPriceEvidenceReviews.map((review) => ({ ...review, tags: [...review.tags] })),
    countedAt: "2026.08.25",
    nextUpdateAt: "미정",
  },
  reviews: {
    slug: "reviews",
    label: "후기",
    count: ultheraEvidenceCounts.reviews,
    articleTitle: "울쎄라 후기 글로 돌아가기",
    returnDescription: "후기를 고르는 여섯 가지 기준 중 아직 못 읽은 게 있다면 이어서 보세요.",
    reviews: [
      { grade: "S", source: "네이버", date: "2026.06.21", text: "직후엔 엥? 똑같은데? 했는데 두달뒤 사진 비교해보니 확실히 다르긴하네요 신기ㅋㅋ", tags: ["01절 근거"] },
      { grade: "A", source: "모두닥", date: "2026.05.19", text: "후기볼때 샷수랑 어디 받았는지 적힌것만 보세요 그게 젤 도움됨!!", tags: ["02절 근거"] },
      { grade: "B", source: "구글", date: "2026.04.11", text: "300샷 받은 후기랑 600샷을 같은결과로 보면 안되겠더라고요. 저도 받고나서 알았음", tags: ["03절 근거"] },
      { grade: "D", source: "카카오", date: "2026.07.01", text: "눈앞에서 새 카트리지 뜯어주셔서 안심됐어요🙂 이런거 은근 중요하더라구요", tags: ["04절 근거"] },
    ],
  },
  pain: {
    slug: "pain",
    label: "통증·마취",
    count: ultheraEvidenceCounts.pain,
    articleTitle: "울쎄라 통증·마취 글로 돌아가기",
    returnDescription: "통증과 마취에 관한 여섯 문장 중 아직 못 읽은 게 있다면 이어서 보세요.",
    reviews: ultheraPainEvidenceReviews.map((review) => ({ ...review, tags: [...review.tags] })),
    countedAt: "2026.08.31",
    nextUpdateAt: "미정",
  },
  recovery: {
    slug: "recovery",
    label: "회복·다운타임",
    count: ultheraEvidenceCounts.recovery,
    articleTitle: "울쎄라 회복·다운타임 글로 돌아가기",
    returnDescription: "회복 과정에 관한 여섯 문장 중 아직 못 읽은 게 있다면 이어서 보세요.",
    reviews: ultheraRecoveryEvidenceReviews.map((review) => ({ ...review, tags: [...review.tags] })),
    countedAt: "2026.08.25",
    nextUpdateAt: "미정",
  },
}

export function isEvidenceTopic(value: string): value is EvidenceTopicSlug {
  return evidenceTopics.includes(value as EvidenceTopicSlug)
}
